/* Sonic Racewear — free shipping offer: countdown + cart drawer progress */
(() => {
  if (window.__srFreeShip) return;
  window.__srFreeShip = true;

  const pad = (n) => String(n).padStart(2, '0');
  const reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  const split = (ms) => {
    const t = Math.max(0, Math.floor(ms / 1000));
    return { d: Math.floor(t / 86400), h: Math.floor((t % 86400) / 3600), m: Math.floor((t % 3600) / 60), s: t % 60 };
  };

  /* ---------- <sr-countdown data-end="ISO" [data-format="short"]> ---------- */
  class SrCountdown extends HTMLElement {
    connectedCallback() {
      this.end = Date.parse(this.dataset.end);
      if (isNaN(this.end)) return;
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
    }
    tick() {
      const left = this.end - Date.now();
      if (left <= 0) {
        clearInterval(this.timer);
        document.documentElement.classList.add('sr-offer-ended');
        return;
      }
      const p = split(left);
      if (this.dataset.format === 'short') {
        const txt = p.d > 0 ? `${p.d}d ${pad(p.h)}h ${pad(p.m)}m` : `${pad(p.h)}:${pad(p.m)}:${pad(p.s)}`;
        if (this.textContent !== txt) this.textContent = txt;
      } else {
        ['d', 'h', 'm', 's'].forEach((k) => {
          const el = this.querySelector(`[data-u="${k}"]`);
          if (!el) return;
          const v = pad(p[k]);
          if (el.textContent !== v) {
            el.textContent = v;
            if (!reduceMotion) {
              el.classList.remove('sr-tick');
              void el.offsetWidth;
              el.classList.add('sr-tick');
            }
          }
        });
      }
      this.classList.toggle('is-final', p.d === 0);
    }
  }
  if (!customElements.get('sr-countdown')) customElements.define('sr-countdown', SrCountdown);

  /* ---------- <sr-ship-progress> ---------- */
  const KEY = 'srShipPrev';
  const readPrev = () => {
    try {
      const v = sessionStorage.getItem(KEY);
      return v === null ? null : Number(v);
    } catch (e) {
      return null;
    }
  };
  const writePrev = (v) => {
    try {
      sessionStorage.setItem(KEY, String(v));
    } catch (e) {}
  };

  class SrShipProgress extends HTMLElement {
    connectedCallback() {
      this.count = Number(this.dataset.count) || 0;
      this.target = Number(this.dataset.target) || 4;
      this.bornAt = Date.now();
      let prev = readPrev();
      if (prev === null || isNaN(prev)) prev = 0;
      this.play(prev, this.count, false);
      writePrev(this.count);
    }

    pct(v) {
      return Math.min(100, Math.max(0, (v / this.target) * 100));
    }

    setStops(n) {
      this.querySelectorAll('.sr-ship__stop').forEach((s, i) => s.classList.toggle('is-on', i < n));
    }

    play(from, to, replay) {
      const fill = this.querySelector('.sr-ship__fill');
      if (!fill || reduceMotion) {
        this.style.setProperty('--sr-p', this.pct(to) + '%');
        this.setStops(to);
        return;
      }
      this.classList.add('no-anim');
      this.style.setProperty('--sr-p', this.pct(from) + '%');
      this.setStops(from);
      void fill.offsetWidth;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.classList.remove('no-anim');
          this.style.setProperty('--sr-p', this.pct(to) + '%');
          this.setStops(to);
        });
      });
      if (!replay && to > from) {
        if (to >= this.target && from < this.target) {
          setTimeout(() => this.celebrate(), 700);
        } else if (to < this.target) {
          this.nudge();
        }
      }
    }

    nudge() {
      const m = this.querySelector('.sr-ship__msg');
      if (!m) return;
      m.classList.remove('sr-nudge');
      void m.offsetWidth;
      m.classList.add('sr-nudge');
    }

    celebrate() {
      this.classList.remove('is-celebrating');
      void this.offsetWidth;
      this.classList.add('is-celebrating');
      const box = this.querySelector('.sr-ship__confetti');
      if (!box) return;
      const colors = ['#E10600', '#121212', '#FFC400', '#16A34A', '#E10600'];
      for (let i = 0; i < 28; i++) {
        const b = document.createElement('i');
        b.style.setProperty('--x', (Math.random() * 240 - 190).toFixed(0) + 'px');
        b.style.setProperty('--y', (-(Math.random() * 70 + 25)).toFixed(0) + 'px');
        b.style.setProperty('--r', (Math.random() * 720 - 360).toFixed(0) + 'deg');
        b.style.setProperty('--d', (Math.random() * 0.2).toFixed(2) + 's');
        b.style.background = colors[i % colors.length];
        box.appendChild(b);
      }
      setTimeout(() => {
        box.innerHTML = '';
        this.classList.remove('is-celebrating');
      }, 1900);
    }
  }
  if (!customElements.get('sr-ship-progress')) customElements.define('sr-ship-progress', SrShipProgress);

  /* ---------- Keep the progress block inside the cart drawer, always fresh ---------- */
  const SECTION_ID = 'sr-ship-progress';
  let cachedHTML = null;
  let inFlight = null;
  let queued = false;

  const drawerItems = () => document.querySelector('cart-drawer cart-drawer-items');

  function mount(html) {
    const host = drawerItems();
    if (!host) return;
    const existing = host.querySelector(':scope > sr-ship-progress');
    if (!html) {
      if (existing) existing.remove();
      return;
    }
    const tpl = document.createElement('template');
    tpl.innerHTML = html.trim();
    const fresh = tpl.content.querySelector('sr-ship-progress');
    if (!fresh) {
      if (existing) existing.remove();
      return;
    }
    if (existing) {
      if (existing.dataset.sig === fresh.dataset.sig) return;
      existing.replaceWith(fresh);
    } else {
      host.prepend(fresh);
    }
  }

  function refresh() {
    if (inFlight) {
      queued = true;
      return inFlight;
    }
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    inFlight = fetch(`${root}?section_id=${SECTION_ID}`, { credentials: 'same-origin' })
      .then((r) => (r.ok ? r.text() : ''))
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const el = doc.querySelector('sr-ship-progress');
        cachedHTML = el ? el.outerHTML : '';
        mount(cachedHTML);
      })
      .catch(() => {})
      .finally(() => {
        inFlight = null;
        if (queued) {
          queued = false;
          refresh();
        }
      });
    return inFlight;
  }

  function init() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    // The theme re-renders the drawer on every cart change. Re-attach instantly, then refresh.
    let debounce;
    new MutationObserver(() => {
      const host = drawerItems();
      if (host && !host.querySelector(':scope > sr-ship-progress')) {
        if (cachedHTML) mount(cachedHTML);
        clearTimeout(debounce);
        debounce = setTimeout(refresh, 60);
      }
    }).observe(drawer, { childList: true, subtree: true });

    // Replay the fill animation each time the drawer opens.
    let wasActive = drawer.classList.contains('active');
    new MutationObserver(() => {
      const active = drawer.classList.contains('active');
      if (active && !wasActive) {
        const el = drawer.querySelector('sr-ship-progress');
        if (el && typeof el.play === 'function' && Date.now() - el.bornAt > 900) el.play(0, el.count, true);
      }
      wasActive = active;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });

    // Dawn's pub/sub (PUB_SUB_EVENTS is a global const, so it is not on window).
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(refresh, 80));
      }
    } catch (e) {}

    refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
